var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "alphabet-pagination" },
    _vm._l(_vm.alphabet, function(letter) {
      return _c(
        "button",
        {
          key: letter,
          class: [
            "pagination-button",
            { active: letter === _vm.selectedLetter }
          ],
          on: {
            click: function($event) {
              return _vm.selectLetter(letter)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(letter) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }